import { render, staticRenderFns } from "./voice_notice_test.vue?vue&type=template&id=6f503038&scoped=true"
import script from "./voice_notice_test.vue?vue&type=script&lang=js"
export * from "./voice_notice_test.vue?vue&type=script&lang=js"
import style0 from "./voice_notice_test.vue?vue&type=style&index=0&id=6f503038&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f503038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f503038')) {
      api.createRecord('6f503038', component.options)
    } else {
      api.reload('6f503038', component.options)
    }
    module.hot.accept("./voice_notice_test.vue?vue&type=template&id=6f503038&scoped=true", function () {
      api.rerender('6f503038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/poManage/voice_notice_test.vue"
export default component.exports